<div *ngIf="showTemplatesOption || showToggles ? (showSubmitAndCreate$ | async) : false" id="options-section" data-testid="options-section">
    <div *ngIf="!useCondensed" id="subtitle">Options</div>
    <div *ngIf="useCondensed" id="condensed-subtitle">Options</div>
    <div>You can only select one of these optional actions</div>
</div>
<mm-submit-and-create-option [showSubmitAndCreate]="showToggles ? (showSubmitAndCreate$ | async) : false"
    [shouldToggleOff$]="saveAsTemplateToggledOn$"
    [isClientAuthShown]="isClientAuthShown"
    (isSubmitAndCreate)="submitAndCreateToggled($event)"
></mm-submit-and-create-option>
<mm-templates-option *ngIf="showTemplatesOption" data-testid="template-option"
    [shouldToggleOff$]="submitAndCreateToggledOn$" (toggledOn)="saveAsTemplateToggled($event)"></mm-templates-option>
